const status = {
  STARTED: 'started',
  SUCCESS: 'success',
  FAILURE: 'failure'
}

export default status
